import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabaseService from '../services/supabaseService';
import { validateEmail } from '../utils/helpers';
import { FiMail, FiArrowLeft } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { toast } from 'react-hot-toast';

const ForgotPasswordScreen = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateEmail(email)) {
      toast.error('يرجى إدخال بريد إلكتروني صحيح');
      return;
    }
    
    setLoading(true);
    
    try {
      console.log('🔄 Sending password reset email to:', email);
      
      // إرسال بريد استعادة كلمة المرور
      const { error } = await supabaseService.client.auth.resetPasswordForEmail(
        email,
        {
          redirectTo: `${window.location.origin}/reset-password`
        }
      );
      
      if (error) {
        console.error('❌ Reset password error:', error);
        throw error;
      }
      
      console.log('✅ Reset email sent successfully');
      
      // حفظ البريد في localStorage كنسخة احتياطية (اختياري)
      localStorage.setItem('recovery_email', email);
      
      toast.success('تم إرسال الرمز بنجاح، يرجى تفقد بريدك الإلكتروني');
      
      // إرسال الايميل عبر الرابط لضمان وصوله
      navigate(`/verify-recovery?email=${encodeURIComponent(email)}`);
      
    } catch (error) {
      console.error('❌ Error:', error);
      toast.error(error.message || 'فشل إرسال رابط إعادة التعيين');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <motion.div
        className="w-full max-w-md"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* زر العودة في الأعلى */}
        <button
          onClick={() => navigate('/auth')}
          className="mb-6 flex items-center text-gray-500 hover:text-gray-900 transition-colors text-sm font-medium"
        >
          <FiArrowLeft className="ml-2" />
          العودة
        </button>

        {/* العنوان الرئيسي */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900 tracking-tight">نسيت كلمة المرور؟</h2>
          <p className="text-gray-500 mt-2 text-sm">
            أدخل بريدك الإلكتروني وسنرسل لك رمزاً لاستعادة حسابك
          </p>
        </div>
        
        {/* النموذج */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative group">
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
              <FiMail className="text-gray-400 group-focus-within:text-gray-900 transition-colors" />
            </div>
            <input
              type="email"
              className="w-full py-3 pr-10 pl-3 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:border-gray-900 focus:bg-white transition-all text-gray-900 placeholder-gray-400"
              placeholder="البريد الإلكتروني"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gray-900 text-white py-3 rounded-lg font-medium hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed mt-4"
          >
            {loading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white ml-2"></div>
                جاري الإرسال...
              </div>
            ) : (
              'إرسال الرمز'
            )}
          </button>
        </form>

        {/* رابط العودة لتسجيل الدخول */}
        <div className="mt-6 text-center">
          <p className="text-gray-500 text-sm">
            تذكرت كلمة المرور؟{' '}
            <button
              onClick={() => navigate('/auth')}
              className="text-gray-900 font-bold hover:underline transition-colors"
            >
              عودة إلى تسجيل الدخول
            </button>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default ForgotPasswordScreen;